define('taoQtiItem/qtiXmlRenderer/renderers/choices/HotspotChoice',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'hotspotChoice',
        template : tpl
    };
});
